import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import PropTypes from 'prop-types'

import classes from './SortableImageItem.module.scss'

const SortableImageItem = ({ image, index }) => {
  const {
    isDragging,
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
  } = useSortable({ id: image.id })

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    opacity: isDragging ? '0.5' : '1.0',
  }

  return (
    <div
      className={classes.imageWrapper}
      ref={setNodeRef}
      style={style}
      {...attributes}
      {...listeners}
    >
      <img
        className={classes.imageThumbnail}
        src={image.file_url}
        alt={'Selected image ' + index}
      />
    </div>
  )
}

SortableImageItem.propTypes = {
  sortableItemId: PropTypes.string,
  image: PropTypes.shape({
    id: PropTypes.number,
    file_url: PropTypes.string,
  }),
  index: PropTypes.number,
}

export default SortableImageItem
